import * as React from 'react'
import PreviewIcon from '@mui/icons-material/Preview'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridRowId,
  GridToolbar,
} from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import { ResourceModel } from 'types'
import axios from 'axios'
import { base_url } from 'env'
import { toast } from 'react-hot-toast'
import { Box } from '@mui/material'
import SearchBar from './SearchBar'

const searchFields = [
  { value: 'title', label: 'Titre' },
  { value: 'type', label: 'Type (local/remote)' },
  { value: 'id', label: 'ID' },
]

export default function ResourceDataGrid({
  resources,
}: {
  resources: ResourceModel[]
}) {
  const [rows, setRows] = React.useState(resources)
  const [filteredResources, setFilteredResources] = React.useState(resources)
  const navigate = useNavigate()

  React.useEffect(() => {
    setRows(filteredResources)
  }, [filteredResources])

  const handleDeleteClick = (id: GridRowId) => () => {
    if (
      window.confirm(`Êtes-vous sûr de vouloir supprimer cette ressource ?`)
    ) {
      axios
        .delete(`${base_url}/resource/${id}`)
        .then(() => {
          toast.success('Ressource supprimée avec succès.')
          setRows((prevRows) => prevRows.filter((row) => row.id !== id))
        })
        .catch((err) => {
          console.error('Failed to delete resource:', err)
        })
    }
  }

  const columns: GridColDef[] = [
    { field: 'title', headerName: 'Titre', flex: 1, minWidth: 250 },
    { field: 'type', headerName: 'Type', width: 100 },
    { field: 'hasVideo', headerName: 'Vidéo', type: 'boolean', width: 100 },
    {
      field: 'hasMobilePdf',
      headerName: 'PDF Mobile',
      type: 'boolean',
      width: 130,
    },
    {
      field: 'hasPaperPdf',
      headerName: 'PDF Papier',
      type: 'boolean',
      width: 130,
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 120,
      cellClassName: 'actions',
      getActions: ({ id }) => [
        <GridActionsCellItem
          icon={<PreviewIcon />}
          label="Aperçu"
          onClick={() => navigate(`/resource/${id}`)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Modifier"
          onClick={() => navigate(`/resource/${id}/edit`)}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Supprimer"
          onClick={handleDeleteClick(id)}
          color="inherit"
        />,
      ],
    },
  ]

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          margin: '1rem',
          gap: '1rem',
        }}
      >
        <SearchBar
          onSearch={setFilteredResources}
          fields={searchFields}
          originalData={resources}
        />
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        slots={{ toolbar: GridToolbar }}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        pageSizeOptions={[10, 25, 50]}
        disableRowSelectionOnClick
        checkboxSelection
      />
    </Box>
  )
}
